import importLogo from './importLogo';

const getLogo = async (textHex) => {
  const Logo = await importLogo();
  return <Logo shade={textHex} />;
};

export default getLogo;
